import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, LoadingButton, } from '@fortem-monorepo/react-ui';
export const ConfirmationDialog = ({ title, description, action, valid = true, pending, children, ...props }) => {
    return (_jsx(Dialog, { ...props, onOpenChange: (nextOpen) => {
            if (!nextOpen && pending) {
                return;
            }
            props.onOpenChange?.(nextOpen);
            if (!nextOpen) {
                props.onClose?.();
            }
        }, children: _jsxs(DialogContent, { children: [_jsxs(DialogHeader, { children: [_jsx(DialogTitle, { children: title }), description && _jsx(DialogDescription, { children: description })] }), _jsx("div", { children: children }), _jsx(DialogFooter, { children: _jsxs("div", { className: "flex items-center gap-2", children: [_jsx(Button, { size: "sm", variant: 'destructive', type: "button", disabled: pending, onClick: () => {
                                    props.onClose?.();
                                }, children: "Cancel" }), _jsxs(LoadingButton, { size: "sm", variant: 'default', disabled: pending || !valid, onClick: async () => action(), children: ["Confirm ", pending] })] }) })] }) }));
};
